// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.treatments', {
    url: '/treatments',
    templateUrl: 'main/configuration/treatments/treatments.tpl.html',
    data: { pageTitle: 'Treatments' },
  });
};

angular.module('configuration.treatments', []).config(config);
